// extracted by mini-css-extract-plugin
export default {"clLinks":"dashboard_clLinks__Bnke1","dangerHover":"dashboard_dangerHover__iTkSx"};